<div class="bg-hp-gradient-230 h-[6px]"></div>
<div class="flex justify-between pt-4 pr-4 pl-8">

</div>
<div class="flex flex-col justify-center items-center px-10 py-4 gap-4 ">
  <h2>{{data.message}}</h2>
  
  <p-progressSpinner ariaLabel="loading" />

</div>